import { axiosChartInstance } from "config";
import { useAxiosMutation } from "hooks";
import { AddendumAttachment } from "types";

type UploadAddendumAttachmentPayload = {
  addendumId: string;
  file: File;
};

function useUploadAddendumAttachment() {
  return useAxiosMutation(
    ["uploadAddendumAttachment"],
    ({ addendumId, file }: UploadAddendumAttachmentPayload) => {
      const formData = new FormData();
      formData.append("file", file, file.name);
      return axiosChartInstance.post<AddendumAttachment>(
        `v1/addendum/${addendumId}/attachments`,
        formData
      );
    }
  );
}

export type { UploadAddendumAttachmentPayload };
export { useUploadAddendumAttachment };
